import { z } from 'zod';

import { CompanyAuditLogId, CompanyId } from '../../BrandedIds';
import { CompanyAuditLogEventType } from '../../company/CompanyAuditLog';
import { zodTemporalInstant } from '../../Temporal';
import { ExportableActor } from '../util/ExportableActor';

export const ExportableCompanyAuditLog = z
  .object({
    id: CompanyAuditLogId,
    companyId: CompanyId,
    // Only `user` actors create these today, but modeled as ExportableActor for cross-record
    // consistency and to avoid a migration if a non-user creation path appears later. Unset
    // when the original user was deleted (FK is ON DELETE SET NULL).
    actor: ExportableActor.optional(),
    type: CompanyAuditLogEventType,
    comment: z.string(),
    createdAt: zodTemporalInstant,
    updatedAt: zodTemporalInstant,
  })
  .meta({ title: 'CompanyAuditLog' });

export type ExportableCompanyAuditLog = z.infer<typeof ExportableCompanyAuditLog>;
